import React, { useState } from 'react';
import axios from 'axios';

import classNames from 'classnames';
import queryString from 'query-string';
import hyperid from 'hyperid';
import '../visitor.css';

const { REACT_APP_MY_LOBBY_BACKEND_URL } = process.env;
const REFRESH_INTERVAL = 3000;
export const EventsQueue = (props) => {
  const parsedQueryString = queryString.parse(window.location.search);
  const siteId = parseInt(parsedQueryString.siteId, 10);
  const [events, setEvents] = useState(null);
  const [eventsFiltered, setEventsFiltered] = useState(null);
  const [session, setSession] = useState(null);
  const [accountId, setAccountId] = useState(null);
  const [time, setTime] = useState(new Date());

  React.useEffect(() => {
    props.hideLoader();
  }, [props]);

  React.useEffect(() => {
    setInterval(() => {
      setTime(new Date());
    }, 1000);
  }, []);

  React.useEffect(() => {
    if (siteId) {
      getSite().then((site) => {
        setAccountId(site.accountId);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteId, session]);

  React.useEffect(() => {
    let interval;
    if (accountId) {
      getEvents(accountId);
      interval = setInterval(() => {
        getEvents(accountId);
      }, REFRESH_INTERVAL);
    }
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId]);

  React.useEffect(() => {
    if (events) {
      const now = new Date().getTime();
      const dayEnd = new Date().setUTCHours(23, 59, 59, 999);
      const filteredEvents = events.filter((e) => e.bookedTimeOut >= now && e.bookedTimeIn <= dayEnd);
      filteredEvents.sort((a, b) => {
        return a.bookedTimeIn - b.bookedTimeIn;
      });
      setEventsFiltered(filteredEvents);
    }
  }, [events]);

  const getEvents = async (accountId) => {
    let sess = session;
    if (!sess) sess = await initSession();
    const body = JSON.stringify({
      accountId: accountId,
    });
    const { data } = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/rooms_reservations/list`, body, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: sess.id,
      },
    });
    if (data && data.reservations) {
      setEvents(data.reservations);
    } else {
      console.log(`Error:`, data);
    }
  };

  const getSite = async () => {
    let sess = session;
    if (!sess) sess = await initSession();
    const { data } = await axios.get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/sites/${siteId}`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: sess.id,
      },
    });
    return data.site;
  };

  const initSession = async () => {
    const id = hyperid().uuid;
    await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users`, {
      email: `${id}@my-lobby.com`,
      password: `${id}@my-lobby.com`,
      siteId: siteId,
    });
    const login = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users/login`, {
      email: `${id}@my-lobby.com`,
      password: `${id}@my-lobby.com`,
      siteId: siteId,
    });
    setSession(login.data);
    return login.data;
  };

  const getTimeAMPMFormat = (timeStamp, start) => {
    const date = new Date(timeStamp);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    if (start) {
      return hours + ':' + minutes;
    }
    return hours + ':' + minutes + ' ' + ampm;
  };

  if (!siteId) {
    return <div style={{ fontSize: 30 }}>No Site Id provided</div>;
  }

  const siteLogoUrl = session && siteId ? `${REACT_APP_MY_LOBBY_BACKEND_URL}/api/sites/getLogo/${siteId}?access_token=${session.id}` : '';
  return (
    <div id="Outer" style={{ backgroundColor: 'black' }}>
      <div className="table-responsive" style={{ height: 880 }}>
        <table>
          <tbody>
            <tr style={{ backgroundColor: 'black', borderBottomColor: 'white', borderBottomWidth: 1 }}>
              <th style={{ color: 'white', backgroundColor: 'black', fontSize: 64, fontWeight: 700 }}>Event Name</th>
              <th style={{ color: 'white', backgroundColor: 'black', fontSize: 64, fontWeight: 700 }}>Time</th>
              <th style={{ color: 'white', backgroundColor: 'black', fontSize: 64, fontWeight: 700 }}>Conference Room</th>
            </tr>
            {!eventsFiltered ? (
              <tr className="activee">
                <td></td>
                <td>Please wait...</td>
                <td></td>
              </tr>
            ) : (
              eventsFiltered.map((event) => {
                if (event.status === 'cancelled' || event.timeOut) return null;
                return (
                  <tr
                    key={`${event.id}event`}
                    style={{ borderBottomColor: 'white', borderBottomWidth: 1 }}
                    className={classNames({ activee: event.timeIn >= new Date().getTime() && !event.timeOut })}
                  >
                    <td style={{ color: 'white', backgroundColor: 'black', textAlign: 'center', fontWeight: 400 }}>{event.title}</td>
                    <td style={{ color: 'white', backgroundColor: 'black', textAlign: 'center', fontWeight: 400 }}>{`${getTimeAMPMFormat(
                      event.bookedTimeIn,
                      true,
                    )}-${getTimeAMPMFormat(event.bookedTimeOut, false)}`}</td>
                    <td style={{ color: 'white', backgroundColor: 'black', textAlign: 'center', fontWeight: 400 }}>{event.roomName}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          backgroundColor: 'black',
          display: 'flex',
          flex: 1,
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
          borderTopColor: 'white',
          borderTopWidth: 1,
        }}
      >
        <div style={{ width: '50%', paddingLeft: 60 }}>{siteLogoUrl && <img style={{ height: 200 }} src={siteLogoUrl} alt="site logo" />}</div>
        <span style={{ marginTop: 'auto', marginBottom: 'auto', fontSize: 60, color: 'white', paddingRight: 60 }}>{getTimeAMPMFormat(time, false)}</span>
      </div>
    </div>
  );
};
